<div>
  <div class="price-section">
    <div class="section-header">
      <h3>Payment Information</h3>
    </div>
    <div class="title">
      <h3>Add New Payment Method</h3>
      <p>
        *By entering your new payment information, you will update your payment
        method on file. This will override your current payment method and be
        used for all future transactions.
      </p>
    </div>

    <app-chargify-form
      (validationSuccess)="onValidationSuccess($event)"
      (validationFailure)="onValidationFailure()"
      (isAchChange)="onPaymentMethodChange($event)"
      (achTermsAcceptedChange)="onAchTermsAcceptedChange($event)"
    ></app-chargify-form>

    <div class="stepperControls padding s6 all">
      <div class="button-container">
        <button mat-button class="backsubs-button" (click)="navigateBack()">
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
        <button
          mat-raised-button
          class="nextStepButton"
          (click)="handlePaymentUpdate()"
          [disabled]="isUpdateButtonDisabled()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</div>
